import { useContext, useState } from "react";
import { CollapseGroup } from "capitalrx-components-2.0/lib/general";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import styles from "./WhiteLabelHomeFAQs.module.scss";
import { ThemeSelectorContext } from "@/context/index";
import { getCardBrandName, getCardBrandText } from "@/utils/branding";

export const HomeFAQs = () => {
  const [expandedIds, setExpandedIds] = useState<ReadonlyArray<string>>([]);
  const { clientDisplayName } = useContext(ThemeSelectorContext);
  const cardBrandName = getCardBrandName(clientDisplayName);
  const cardBrandText = getCardBrandText(clientDisplayName);

  return (
    <div className={styles.HomeFaqs}>
      <Paragraph textAlign="center" className={styles.HomeFaqsTitle}>
        Frequently Asked Questions:
      </Paragraph>
      <CollapseGroup
        alignCaret="left"
        appearance="blank"
        expandedIds={expandedIds}
        onExpandedIdsChange={setExpandedIds}
        className={styles.HomeFaqsAccordion}
      >
        <CollapseGroup.Collapse id="faq1" title="Am I eligible to use this card?">
          Everyone is eligible to use the {cardBrandText}. While this is not a health insurance program, presenting this prescription
          savings card to the pharmacist can help you and your family get discounts on your prescriptions.
        </CollapseGroup.Collapse>
        <CollapseGroup.Collapse id="faq2" title="Do I need to pay for this card?">
          No. We believe in affordable and ethical healthcare. The {cardBrandName} prescription savings card is free to download.
        </CollapseGroup.Collapse>
        <CollapseGroup.Collapse id="faq3" title="How do I use this card?">
          Simply present the card to your pharmacist when you fill your prescriptions to find discounts on your prescriptions. This card is
          not a health insurance program and cannot be combined with any other third-party insurance, including Medicare and Medicaid.
        </CollapseGroup.Collapse>
        <CollapseGroup.Collapse id="faq4" title="Which medications are covered?">
          The {cardBrandText} helps you to save on most of the prescriptions that you and your family depend on to live healthy
          lives.
        </CollapseGroup.Collapse>
        <CollapseGroup.Collapse id="faq5" title="What pharmacies accept this card?">
          To find a pharmacy that accepts the {cardBrandText}, look up your medication in the Find Best Price tool.
          Ask your pharmacy to run the card and check the price, even if they tell you they have another card they use.
        </CollapseGroup.Collapse>
        <CollapseGroup.Collapse id="faq6" title="Will the price shown on the website be the price I get at the pharmacy?">
          Most likely yes. The price could differ if you searched for a different quantity or strength than your prescription.
          In addition, our price based upon an estimate of which NDC (national drug code) is most common for the selected strength
          and form of the drug. If your pharmacy has a different NDC drug in stock, the price may differ as there could be multiple
          prices for the same drug if they have different manufacturers.
        </CollapseGroup.Collapse>
      </CollapseGroup>
    </div>
  );
};
